import { DocumentStatus } from '@app/entities/enums/ptrab/documents/document-status.enum';

export class DocumentUrl {
  url!: string;
  status!: DocumentStatus;
}
